import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import useStore from "./composables/useStore";
import { MOUNT_POINT } from "./config";
import patchDomTree from "./functions/patchDomTreeV2";
import de from "@/i18n/de";
import en from "@/i18n/en";

export function initialize() {
    const { initializeStore } = useStore();

    const i18n = createI18n({
        locale: document.documentElement.lang,
        fallbackLocale: "de-DE",
        messages: {
            de: de,
            "de-DE": de,
            "de-AT": de,
            "de-CH": de,
            "de-LI": de,
            "de-LU": de,
            en: en,
            "en-AU": en,
            "en-BZ": en,
            "en-CA": en,
            "en-CB": en,
            "en-GB": en,
            "en-IE": en,
            "en-JM": en,
            "en-NZ": en,
            "en-PH": en,
            "en-TT": en,
            "en-ZW": en
        }
    });

    patchDomTree();
    initializeStore();
    createApp(App)
        .use(i18n)
        .mount(`#${MOUNT_POINT}`);
}

if (document.readyState === "complete") {
    initialize();
} else {
    window.addEventListener("DOMContentLoaded", initialize);
}
